import { Component, OnInit } from '@angular/core';
import { LoginService } from './login/login.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  
  constructor(
    private loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.loginService.initUserFromLocalStorage();
  }
}
